'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var defaultProps = {};

exports.__exports = defaultProps;
